// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__F0FKq","content":"Consent_content__2QbgG","footer":"Consent_footer__1l160"};